import { animate, style, transition, trigger } from '@angular/animations';

/** @deprecated use `AppearWithHeightAndOpacity` instead */
export const AppearWithHeight = trigger('appear', [
  transition(':enter', [style({ height: 0 }), animate('150ms ease-in', style({ height: '*' }))]),
  transition(':leave', [style({ height: '*' }), animate('150ms ease-out', style({ height: 0 }))]),
]);

export const AppearWithHeightAndOpacity = trigger('appear', [
  transition(':enter', [
    style({ height: 0, opacity: 0 }),
    animate('150ms ease-in', style({ height: '*', opacity: 1 })),
  ]),
  transition(':leave', [
    style({ height: '*', opacity: 1 }),
    animate('150ms ease-out', style({ height: 0, opacity: 0 })),
  ]),
]);
